// import logo from './logo.svg';
import './App.css';
import PathfindingVisualiser from './PathfindingVisualiser/PathfindingVisualiser';

function App() {
  return (
    <div className="App">
      <PathfindingVisualiser></PathfindingVisualiser>
    </div>
  );
}

export default App;
